import { api } from '@/utils/api'
import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * トップ画面表示用情報取得
 */
export namespace ApiTaTp010 {
  // API Name
  export const name: string = 'ApiTaTp010'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/topContent'

    export interface Request {
      query: {
        courseId: string
        planId: string
      }
    }

    export interface Curriculum {
      unitsId: string // 配信単位ID (毎月月号が配信されるたびに増えていく)
      curriculumId: string // 教科ID
      boldFlg: string // ボタン強調表示フラグ (0:非強調、1:強調)
      badgeFlg: string // バッジ区分 (1:はなまる、2:遅れ大、3:遅れ)
      lessonId: string // 学習コマID (毎月月号が配信されるたびに増えていく)
      pieceType: string // コマ区分
    }

    export interface Response {
      curriculums: Array<Curriculum>
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        curriculums: [
          {
            unitsId: '',
            curriculumId: '',
            boldFlg: '',
            badgeFlg: '',
            lessonId: '',
            pieceType: '',
          },
        ],
      }

      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
